import { render } from "./GoCaptchaBtnDialog.vue?vue&type=template&id=213120df"
import script from "./GoCaptchaBtnDialog.vue?vue&type=script&lang=js"
export * from "./GoCaptchaBtnDialog.vue?vue&type=script&lang=js"

import "./GoCaptchaBtnDialog.vue?vue&type=style&index=0&id=213120df&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__